// Copyright (c) 2017 Deere & Company

const closingAccountSortOptions = [
    {
        displayName: 'CLOSING',
        path: ['businessEndDate']
    }
];

export default closingAccountSortOptions;



// WEBPACK FOOTER //
// ./src/tcsm/wip/services/closing-account-sort-options.js